import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';

/** Sticky call to action, shown only on the narrow composition. */
export function MobileBar() {
  const { t } = useTranslation(['common']);

  return (
    <div className="mobilebar">
      <span className="mobilebar__text">{t('common:mobileBar.status')}</span>
      <a className="mobilebar__cta" href={`mailto:${profile.email}`}>
        {t('common:mobileBar.cta')}
      </a>
    </div>
  );
}
